"use client"

import * as React from "react"
import {styled, useThemeProps} from "@mui/material/styles"
import {LabelProps} from "@/types/form";


const LabelRoot = styled("label", {
    name: "MuiLabel",
    slot: "Root",
})(({theme}) => ({
    display: "inline-block",
    color: theme.palette.text.primary,
}))

export default function Label(inProps: LabelProps) {
    const props = useThemeProps({name: "MuiLabel", props: inProps})
    const {children, htmlFor, ...other} = props

    return (
        <LabelRoot htmlFor = {htmlFor} {...other}>
            {children}
        </LabelRoot >
    )
}
